module.exports = __webpack_public_path__ + "static/media/Kevin Chan.c60bec7b.png";